<header>
    <h1>{{ 'pages.dashboard.title' | translate }}</h1>
</header>

<iframe [src]="(iframeSrc$ | async) | safeUrl"></iframe> 

<!-- <div class="sdk-charts-container">
    <div #dashboard id="dashboard"></div>
</div> -->

